import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2 } from '@blueprint/ui';
import { VisuallyHidden } from 'shared/components';
import Wrapper from 'shared/components/Content/Wrapper';

const SECONDARY_COLUMN_WIDTH_LARGE = '20rem';
const SECONDARY_COLUMN_WIDTH_EXTRA_LARGE = '25rem';

/*
    Because the Layout is changed to `main`, IE11 needs
    display: block to render the page properly
*/
const Layout = styled(Wrapper)`
    display: block;
`;

export const Page = Layout.withComponent('main');

export const Primary = styled('div')(
    ({ theme: { mq } }) => css`
        position: relative;
        ${mq.large} {
            padding-right: ${SECONDARY_COLUMN_WIDTH_LARGE};
        }
        ${mq.extraLarge} {
            padding-right: ${SECONDARY_COLUMN_WIDTH_EXTRA_LARGE};
        }
    `
);

export const Secondary = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        margin-top: ${spacing['32px']};

        ${mq.large} {
            height: 100%;
            margin-top: 0;
            padding-bottom: ${spacing['24px']};
            position: absolute;
            right: 0;
            top: 0;
            width: calc(${SECONDARY_COLUMN_WIDTH_LARGE} - ${spacing['24px']});
        }
        ${mq.extraLarge} {
            width: calc(
                ${SECONDARY_COLUMN_WIDTH_EXTRA_LARGE} - ${spacing['24px']}
            );
        }
    `
);

export const SecondaryContent = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        ${mq.large} {
            position: sticky;
            top: ${spacing['24px']};
            left: 0;
        }
    `
);

export const SectionHeading = styled(Heading2)(
    ({ theme }) => css`
        margin-bottom: ${theme.spacing['16px']};

        ${theme.mq.medium} {
            margin-bottom: ${theme.spacing['24px']};
        }
    `
);

export const VisuallyHiddenHeading = VisuallyHidden.withComponent('h2');

export const SummaryDetailsAndGalleryContainer = styled('div')(css`
    display: flex;
    flex-direction: column-reverse;
`);

export const GalleryContainer = styled('section')(
    ({ theme: { colors, spacing, mq } }) => {
        return css`
            position: relative;
            background: ${colors['grey-aluminium']};
            outline: 1px solid ${colors.white};
            width: calc(100% + 2 * ${spacing['16px']});
            margin-left: -${spacing['16px']};
            ${mq.large} {
                width: 100%;
                margin-left: 0;
            }
        `;
    }
);

export const NavContainer = styled(Wrapper)`
    display: flex;
    align-items: flex-start;
`;

export const GalleryUserActionsContainer = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        position: absolute;
        top: ${spacing['8px']};
        right: ${spacing['8px']};

        ${mq.medium} {
            top: ${spacing['16px']};
            right: ${spacing['16px']};
        }

        ${mq.large} {
            display: none;
        }
    `
);

export const AmenitiesContainer = styled('section')();

export const TourFloorplansContainer = styled('div')(
    ({ theme: { mq } }) => css`
        display: none; /* temporary hide for mobile */
        ${mq.medium} {
            display: flex; /* temporary show for desktop */
            min-height: 16.25em;
        }
    `
);

export const UserActionsContainer = styled('div')(
    ({ theme: { mq } }) => css`
        ${mq.large} {
            display: none;
        }
    `
);

export const FeaturesContainer = styled('section')(
    ({ theme }) => css`
        padding: ${theme.spacing['24px']} 0;
    `
);

export const MapContainer = styled('section')();

export const AdContainer = styled('div')(
    ({ theme: { mq } }) => css`
        margin: 0 auto;

        ${mq.medium} {
            max-width: 25rem;
        }
    `
);

export const AgentDetailsContainer = styled('section')();

export const AgentDetailsHeading = styled(Heading2)(
    ({ theme: { mq, spacing } }) => css`
        margin: ${spacing['16px']} 0;
        ${mq.large} {
            display: none;
        }
    `
);

export const RecentSales = styled('div')(
    ({ theme: { spacing } }) => css`
        display: inline-block;
        margin-top: ${spacing['16px']};
    `
);
